import { pb } from '@/core/api';
import {
  translateErrorMap,
  translateFieldError,
} from '../utils/field-error-messages';
import type {
  NewMemberData,
  NewMemberFieldErrors,
} from './use-new-member-form';

export type Payload = {
  first_name: string;
  last_name: string;
  ig_username: string;
  personal_ig_username?: string;
  email: string;
  phone: string;
  country: string;
  city: string;
  birthdate: string;
  password: string;
  password_confirm: string;
  role: string;
  usdc_wallet?: string;
  account_status?: string;
};

type ErrShape = { errors?: Record<string, string>; error?: string };

export type CreateOutcome =
  | { ok: true; id: string; player_number?: number }
  | { ok: false; fieldErrors?: NewMemberFieldErrors; message?: string };

export function buildPayload(d: NewMemberData, forcedStatus: string): Payload {
  const payload: Payload = {
    first_name: d.first_name.trim(),
    last_name: d.last_name.trim(),
    ig_username: d.ig_username.trim(),
    email: d.email.trim(),
    phone: `${d.phone_prefix}${d.phone_number}`.trim(),
    country: d.country,
    city: d.city.trim(),
    birthdate: d.birthdate,
    password: d.password,
    password_confirm: d.password_confirm,
    role: d.role,
  };
  if (d.usdc_wallet) payload.usdc_wallet = d.usdc_wallet.trim();
  if (d.personal_ig_username) {
    payload.personal_ig_username = d.personal_ig_username.trim();
  }
  if (forcedStatus) payload.account_status = forcedStatus;
  return payload;
}

export async function uploadPhoto(
  id: string,
  file: globalThis.File
): Promise<void> {
  const form = new globalThis.FormData();
  form.append('photo', file);
  await pb.send(`/api/team-members/verification-photo/${id}`, {
    method: 'POST',
    body: form,
  });
}

export function parseError(err: unknown): CreateOutcome {
  const e = err as { response?: ErrShape };
  const r = e.response ?? {};
  if (r.errors) {
    return { ok: false, fieldErrors: translateErrorMap(r.errors) };
  }
  if (r.error) return { ok: false, message: translateFieldError(r.error) };
  return { ok: false, message: 'Error al crear miembro' };
}
